/** 366 (the owner, option A): a tree's overall scale, drawn from its species' range (constants/action.ts `TREE_SCALE_RANGE`). */
import { TREE_SCALE_DEFAULT, TREE_SCALE_RANGE } from '../constants/action';

/** One draw, as the single 0.85–1.15 was, so the draws after it keep their places. */
export function treeScale(floraType: string, rng: { range(lo: number, hi: number): number }): number {
  const [lo, hi] = TREE_SCALE_RANGE[floraType] ?? TREE_SCALE_DEFAULT;
  return rng.range(lo, hi);
}
